// src/components/Logout.js

import { useNavigate } from "react-router-dom";
import React, { useEffect } from "react";
import { Backdrop, CircularProgress } from "@mui/material";
import { useAuth } from "react-oidc-context";

const Logout = () => {
  const navigate = useNavigate();
  const auth = useAuth();

  useEffect(() => {
    document.title = "Logout | Kloudscan";
  }, []);

  useEffect(() => {
    const REDIRECT_DELAY = 1500;

    const timer = setTimeout(() => {
      // Remove specific auth-related localStorage keys
      localStorage.removeItem("authState");
      localStorage.removeItem("logoutInitiator");

      // Remove OIDC-related keys safely
      for (const key of Object.keys(localStorage)) {
        if (key.startsWith("oidc.")) {
          localStorage.removeItem(key);
        }
      }

      // Remove session storage flags
      sessionStorage.removeItem("logoutInProgress");

      // Clear auth session from OIDC library
      auth.removeUser();

      // ❌ Intentionally NOT clearing everything anymore
      // localStorage.clear();
      // sessionStorage.clear();

      navigate("/");
    }, REDIRECT_DELAY);

    return () => clearTimeout(timer);
  }, [auth, navigate]);

  return (
    <Backdrop
      sx={(theme) => ({ color: "#fff", zIndex: theme.zIndex.drawer + 1 })}
      open={true}
    >
      <CircularProgress color="inherit" />
    </Backdrop>
  );
};

export default Logout;
